import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { FeedbackProactiveConfiguration } from './configuration';
import { HttpClient } from '@angular/common/http';

import { FeedbackProactiveService } from './api/feedbackProactive.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class FeedbackProactiveApiModule {
    public static forRoot(configurationFactory: () => FeedbackProactiveConfiguration): ModuleWithProviders<FeedbackProactiveApiModule> {
        return {
            ngModule: FeedbackProactiveApiModule,
            providers: [ { provide: FeedbackProactiveConfiguration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: FeedbackProactiveApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('FeedbackProactiveApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
